import React from "react";
import { Share2, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  BackButton,
  Container,
  Content,
  Footer,
  HeroImage,
  Meta,
  ShareButton,
  Title,
  Wrapper,
} from "./LifeInsuranceIn2026";

/* ✅ NEW: Gallery Styles */
const Gallery = styled.div`
  margin: 40px 0;
  display: grid;
  gap: 16px;

  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 384px;
  object-fit: cover;
  border-radius: 12px;

  @media (max-width: 768px) {
    height: 100%;
  }
`;

const AwarenessInitiativeBlog = () => {
  const navigate = useNavigate();

  const blog = {
    title: "Small Steps Today. Big Dreams Tomorrow.",
    author: "Team Wealthies",
    date: "April 2026",
    image: "/assets/awarenessImg4.jpeg",

    /* ✅ NEW: Gallery Images */
    gallery: [
      "/assets/awarenessImg1.jpeg",
      "/assets/awarenessImg2.jpeg",
      "/assets/awarenessImg3.jpeg",
    ],
  };

  const handleShare = async () => {
    const shareData = {
      title: blog.title,
      text: "Check out this article",
      url: window.location.href,
    };

    if (navigator.share) {
      await navigator.share(shareData);
    } else {
      await navigator.clipboard.writeText(shareData.url);
      alert("Link copied!");
    }
  };

  return (
    <Container>
      <Wrapper>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back
        </BackButton>

        <Title>{blog.title}</Title>
        <Meta>
          {blog.date} • {blog.author}
        </Meta>

        <HeroImage src={blog.image} />

        <Content>
          <p>Some moments remind us why we started.</p>

          <p>
            During our recent awareness initiative, we had the opportunity to
            interact with young children and their parents — and it was a truly
            meaningful experience.
          </p>

          <p>
            Children don’t think about planning or future security. They simply
            learn, smile, and dream freely.
          </p>

          <p>
            But behind every child’s smile, there is a parent thinking about
            tomorrow.
          </p>

          {/* ✅ IMAGE GALLERY */}
          <Gallery>
            {blog.gallery.map((img, index) => (
              <GalleryImage key={index} src={img} alt={`event-${index}`} />
            ))}
          </Gallery>

          <h2>🌱 A Step Towards Awareness</h2>
          <p>
            At Wealthies, we believe that financial awareness doesn’t begin with
            complexity — it begins with simple conversations.
          </p>

          <p>
            Through this initiative, we connected with families and shared the
            importance of understanding financial protection, planning early,
            and making informed decisions for the future.
          </p>

          <p>
            It was not about selling or promoting anything — it was about
            creating awareness and clarity.
          </p>

          <h2>👨‍👩‍👧‍👦 The Role of Parents</h2>
          <p>Every parent wants to give their child:</p>

          <ul>
            <li>Better opportunities</li>
            <li>A secure future</li>
            <li>The confidence to achieve their dreams</li>
          </ul>

          <p>
            And sometimes, even small steps taken today can create a strong
            foundation for tomorrow.
          </p>

          <p>
            This initiative was a reminder that awareness and understanding play
            a key role in building that foundation.
          </p>

          <h2>💙 A Heartfelt Thank You</h2>
          <p>
            We would like to express our sincere gratitude to{" "}
            <strong> Little Friends Pre School, Gottigere, Bangalore</strong>{" "}
            for giving us this wonderful opportunity.
          </p>

          <p>
            Their support made it possible for us to connect with families and
            share meaningful insights in a warm and welcoming environment.
          </p>

          <h2>🌟 What This Means to Us</h2>
          <p>
            This was not just an event — it was a step towards our larger
            mission:
          </p>

          <p>
            Making financial awareness simple, accessible, and meaningful for
            every individual.
          </p>

          <p>
            Every interaction, every conversation, and every small effort
            contributes to building something bigger.
          </p>

          <h2>✨ Closing Thought</h2>
          <p>
            Because every child deserves not just dreams, but a future strong
            enough to achieve them.
          </p>

          <p>
            <strong>Small Steps Today. Big Dreams Tomorrow.</strong>
          </p>

          <p>— Team Wealthies</p>
        </Content>

        <Footer>
          <ShareButton onClick={handleShare}>
            <Share2 size={18} /> Share
          </ShareButton>
        </Footer>
      </Wrapper>
    </Container>
  );
};

export default AwarenessInitiativeBlog;
